export const set = (key, value, expirySeconds) => {
  const now = new Date()
  const item = {
    value: value,
    expiry: now.getTime() + expirySeconds * 1000
  }
  localStorage.setItem(key, JSON.stringify(item))
}

export const get = key => {
  const itemString = localStorage.getItem(key)
  if (!itemString) {
    return null
  }
  const item = JSON.parse(itemString)
  const now = new Date()
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

export const remove = key => {
  localStorage.removeItem(key)
}

export const clear = () => {
  localStorage.clear()
}

const vueLocalStorageWithExpiry = {
  install(Vue) {
    Vue.prototype.$localStorage = {
      set,
      get,
      remove,
      clear
    }
  }
}

export default vueLocalStorageWithExpiry



// WEBPACK FOOTER //
// ./src/utils/VueLocalsotrageWithExpiry.js